.button {
  font-size: 1.5rem;
  float: left;
  width: 3rem;
  height: 100%;
  padding: 0;
  color: inherit;
  border: none;
  outline: none;
  background: none;

  &:hover,
  &.active {
    color: #f0f0f0 !important;
  }

  &.close:hover,
  &.close.active {
    background: #e20000;
  }

  &.maximize:hover,
  &.maximize.active,
  &.minimize:hover,
  &.minimize.active {
    background: var(--primary-color);
  }

  i {
    font-size: 1.4rem;
    line-height: 3rem;
  }
}

.buttons {
  position: absolute;
  top: 0;
  left: 0;
  height: 3rem;
}

.title {
  font-family:
    Lucida Sans Unicode,
    Lucida Grande,
    sans-serif;
  font-size: 1.4rem;
  font-weight: inherit;
  line-height: 3rem;
  width: 100%;
  height: 3rem;
  margin: 0;
  text-align: center;
}

.titleBar {
  font-family: var(--font-family), sans-serif;
  font-size: 1.4rem;
  line-height: 3rem;
  height: 3rem;
  text-align: center;
  border-top-left-radius: var(--radius-8);
  border-top-right-radius: var(--radius-8);

  &,
  * {
    cursor: default;
    user-select: none;
  }

  .close {
    border-top-left-radius: var(--radius-8);
  }
}

.frozen {
  pointer-events: none;
}

:global(.keyboardFocused) .button {
  &:focus {
    color: #f0f0f0 !important;
  }

  &.close:focus {
    background: #e20000;
  }

  &.maximize:focus,
  &.minimize:focus {
    background: var(--primary-color);
  }
}

@media only screen and (max-width: 1024px) {
  .titleBar {
    display: none;
  }
}
